export default interface Tag {
  id: number;
  name: string;
  type: TagType;
  organizationId: number;
  isArchived: boolean;
}

export enum TagType {
  AREA_OF_OPERATION = 'area_of_operation',
  AGE_DIVISION = 'age_division',
  COMPETITION_GENDER = 'competition_gender',
  COMPETITION_LEVEL = 'competition_level',
}

export const unarchivedOrgTagsForType = (orgTags: any[], tagType: TagType) =>
  orgTags?.filter((tag) => tag.type === tagType && !tag.isArchived).sort((a, b) => a.id - b.id) || [];

export const selectableOrgTagsForType = (orgTags: any[], tagType: TagType, existingSelectedTags: any[]) => {
  let tags = unarchivedOrgTagsForType(orgTags, tagType);

  const selectedArchivedTags =
    orgTags?.filter(
      (tag) =>
        tag.type === tagType && tag.isArchived && existingSelectedTags?.find((simpleTag) => simpleTag.id == tag.id)
    ) || [];

  tags = [...tags, ...selectedArchivedTags];

  return tags && tags.sort((a, b) => a.id - b.id);
};
